import { useState } from 'react';
import { categories } from '@/mocks/comics';

const accentMap: Record<number, string> = {
  0: 'bg-accent-500/15 text-accent-300',
  1: 'bg-secondary-500/15 text-secondary-300',
  2: 'bg-primary-500/15 text-primary-300',
  3: 'bg-accent-500/15 text-accent-300',
  4: 'bg-secondary-500/15 text-secondary-300',
  5: 'bg-primary-500/15 text-primary-300',
  6: 'bg-accent-500/15 text-accent-300',
  7: 'bg-secondary-500/15 text-secondary-300',
};

export default function Categories() {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <section id="category" className="w-full bg-background-900/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400">
              <i className="ri-grid-fill" />
              CATEGORIES
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              按口味选漫画
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-400 md:text-base">
              无论你偏爱热血燃向还是暖心日常，这里都有覆盖全题材的人气分类，点击即达。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-focus-3-line text-sm text-primary-400" />
            共 {categories.length} 大主题分类
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, i) => {
            const active = selected === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => setSelected(active ? null : cat.id)}
                className={`flex items-start gap-4 rounded-xl border p-5 text-left transition-all ${
                  active
                    ? 'border-primary-500/60 bg-primary-500/10'
                    : 'border-background-800 bg-background-950 hover:border-primary-500/40 hover:bg-background-900'
                }`}
              >
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-xl ${accentMap[i % 8]}`}>
                  <i className={cat.icon} />
                </span>
                <span className="flex flex-col gap-1">
                  <span className="font-heading text-base font-bold text-foreground-50">{cat.name}</span>
                  <span className="text-xs text-foreground-400">{cat.desc}</span>
                  <span className="mt-1 inline-flex items-center gap-1 text-xs font-medium text-primary-400">
                    <i className="ri-stack-line text-[11px]" />
                    {cat.count} 部作品
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}